import type { GlobalMetrics } from '@/types/metrics';
import type { Store } from '@/types/store';

const MAX_HISTORY = 24;

function clamp(v: number, min: number, max: number) { return Math.max(min, Math.min(max, v)); }
function jitter(base: number, pct: number) { return base + base * (Math.random() - 0.5) * pct; }

export function evolveMetrics(
  metrics: GlobalMetrics,
  stores: Store[],
  agentsOnline: number
): GlobalMetrics {
  // Tokens consumed per tick (variable par nombre d'agents actifs)
  const tokensThisTick = Math.round(jitter(agentsOnline * 45, 0.3));
  const newTokensUsed = Math.min(
    metrics.tokensUsedToday + tokensThisTick,
    metrics.totalTokensBudget
  );

  // Revenue: petite montée aléatoire (ventes sporadic)
  const salesRoll = Math.random();
  const revenueDelta = salesRoll < 0.3 ? jitter(18, 0.5) : salesRoll < 0.6 ? jitter(8, 0.4) : 0;
  const newRevenue = metrics.totalRevenue + revenueDelta;
  const avgMarginRate = stores.reduce((s, st) => s + st.metrics.margin, 0) / stores.length;
  const newMargin = metrics.totalMargin + revenueDelta * avgMarginRate;
  const newOrders = metrics.totalOrders + (salesRoll < 0.25 ? 1 : 0);

  const revenueHistory = [...metrics.revenueHistory, Math.round(newRevenue)].slice(-MAX_HISTORY);
  const tokenHistory = [...metrics.tokenHistory, newTokensUsed].slice(-MAX_HISTORY);

  return {
    ...metrics,
    tokensUsedToday: newTokensUsed,
    totalRevenue: clamp(newRevenue, 0, 999999),
    totalMargin: clamp(newMargin, 0, 999999),
    totalOrders: newOrders,
    agentsOnline,
    tick: metrics.tick + 1,
    revenueHistory,
    tokenHistory,
  };
}

export function evolveStoreMetrics(store: Store): Store {
  const sessionDelta = Math.round(jitter(2, 1));
  const orderDelta = Math.random() < 0.2 ? 1 : 0;
  const revenueDelta = orderDelta * jitter(store.metrics.avgOrderValue, 0.2);
  return {
    ...store,
    metrics: {
      ...store.metrics,
      sessions: store.metrics.sessions + sessionDelta,
      orders: store.metrics.orders + orderDelta,
      revenue: store.metrics.revenue + revenueDelta,
    },
  };
}
